import React from "react";
import "../FlightRoster.css";
import { Paper, InputBase, Button } from "@mui/material";
import { SearchOutlined, CloseCircleFilled } from "@ant-design/icons";

const FlightRosterSearch = ({
  searchFlightData,
  setSearchFlightData,
  onClickSearch,
  onClickClearSearch,
}) => {
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchFlightData(value);
  };

  return (
    <div className="flight-roster-search ">
      <Paper component="form" className="paper-style" onSubmit={e => e.preventDefault()}>
        <SearchOutlined className="input-icon" />
        <InputBase
          className="input-style"
          placeholder="Search by Flight Number"
          value={searchFlightData}
          onChange={handleSearchChange}
          inputProps={{ maxLength: 15 }}
        />
        {searchFlightData.length > 0 && (
          <CloseCircleFilled
            className="input-icon"
            onClick={onClickClearSearch}
          />
        )}
        <Button
          variant="contained"
          disabled={searchFlightData.length < 3}
          onClick={onClickSearch}
        >
          Search
        </Button>
      </Paper>
    </div>
  );
};

export default FlightRosterSearch;
